import React, { useEffect, useState, useRef } from "react";
import { Button, CardContent, Stack, Card, Tooltip } from "@mui/material";
import "./style.css";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  useLocation
} from "react-router-dom";
import * as yup from "yup";
import { ToastContainer } from "react-toastify";
import { makeStyles } from "@mui/styles";
import { useNavigate, useParams } from "react-router-dom";
import { useLoader } from "../../../pages/LoaderContext";
import ValidationModal from "../common/ValidationModal";
import { Controller, useForm } from "react-hook-form";
import Grid from "@mui/material/Grid2";
import { useProjectApiClient } from "../../Services/api/projectService";

import { successToast, errorToast } from "../../utils/toast";
import SelectDropdown from "../common/FormSelectDropdown";
import TextInput from "../common/TextInput";
import UnSavedModal from "../common/UnSavedModal";
import { useAppContext } from "../../../hooks/context/AppContext";
import AutoSaveModal from "../common/AutoSaveModal";
import useIdle from "../../../hooks/useIdle";
import { useTechnicalScopesApiClient } from "../../Services/api/TechnicalScopeService";
import { projectVersion } from "config/navConfig";
import MultiSelectDropdown from "../common/FormMultiSelectDropdown";
import FileUpload from "../common/FileUpload";
import UploadList from "../common/UploadsList";
import circleArrowIcon from "../../../assets/images/circle-arrow-icon.svg"
import uploadIcon from "../../../assets/images/upload-icon.svg";

const useStyles = makeStyles({
  themeButton: {
    backgroundColor: "#2a3fbf !important",
    padding: "8px 30px",
    fontWeight: "700",
    "&:hover": { backgroundColor: "#2a3fbf !important" },
  },
  cancelButton: {
    backgroundColor: "#d9d9d9 !important",
    color: "#626262 !important",
    padding: "8px 30px",
    fontWeight: "700",
    "&:hover": {
      backgroundColor: "#d9d9d9 !important",
      color: "#626262 !important",
    },
  },
});

interface AuditEntry {
  fieldName: string;
  oldValue: string;
  newValue: string;
}

const schema = yup.object().shape({
  newChassis: yup.mixed().nullable(),
  newGoodies: yup.mixed().nullable(),
  lockedFormulation: yup.mixed().nullable(),
  format: yup.mixed().nullable(),
  packType: yup.mixed().nullable(),
  lockedPackaging: yup.mixed().nullable(),
  comment: yup.string().nullable(),
  risk: yup.mixed().nullable(),
});

const TechnicalScopeForm: React.FC = () => {
  const location = useLocation();
  const { projectId, projectKey } = useParams<{
    projectKey: string;
    projectId: string;
  }>();
  const { getProjectDetails, getRequiredField, publishProjectOnSave, uploadProjectFile } =
    useProjectApiClient();
  //  API Client for Technical Scopes
  const {
    getRisks,
    getLockedPackagingOptions,
    getNewChassisOptions,
    getNewGoodiesOptions,
    getLockedFormulationOptions,
    getTSFormatOptions,
    getTSPackTypeOptions,
    getTechnicalScopeById,
    createTechnicalScope,
    updateTechnicalScope,

  } = useTechnicalScopesApiClient();

  const { appData, updateAppData, userData } = useAppContext();
  const navigate = useNavigate();
  const classes = useStyles();
  const [risks, setRisks] = useState([]);
  const [newChassis, setNewChassis] = useState([]);
  const [newGoodies, setNewGoodies] = useState([]);
  const [lockedFormulation, setLockedFormulation] = useState([]);
  const [format, setFormat] = useState([]);
  const [packType, setPackType] = useState([]);
  let [lockedPackaging, setLockedPackaging] = useState([]);
  const [isExisting, setIsExisting] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const { setLoading } = useLoader();
  const [validationErrors, setValidationErrors] = useState({});
  const [isValidationError, setIsValidationError] = useState(false);
  const [projectDetails, setProjectDetails] = useState({ issaved: false });
  const [isDraftDisabled, setIsDraftDisabled] = useState(false);
  const [autoSaveModal, setAutoSaveModal] = React.useState<boolean>(false);
  const isIdle = useIdle(60000 * 10);
  const hasAutoSaved = useRef(false);
  const [selectedFormats, setSelectedFormats] = useState<string[]>([]);
  const [existingFormats, setExistingFormats] = useState<any[]>([]);
  const [techScopeId, setTechScopeId] = useState<number | null>(null);
  const [isUpload, setIsUpload] = React.useState<boolean>(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const [formData, setFormData] = useState({
    newChassis: "",
    newGoodies: "",
    lockedFormulation: "",
    format: "",
    packType: "",
    lockedPackaging: "",
    comment: "",
    risk: "",
  });
  const [initialformData, setInitialformData] = useState({
    newChassis: "",
    newGoodies: "",
    lockedFormulation: "",
    format: "",
    packType: "",
    lockedPackaging: "",
    comment: "",
    risk: "",
  });
  const {
    handleSubmit,
    control,
    clearErrors,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  //  Fetch Risks
  useEffect(() => {
    setLoading(true);
    const fetchOptions = async () => {
      await Promise.all([
        fetchRisks(),
        fetchLockedPackaging(),
        fetchNewChassis(),
        fetchNewGoodies(),
        fetchLockedFormulation(),
        fetchTSFormat(),
        fetchTSPackType(),
        fetchsProjectDetails(),
      ]);
    };
    fetchOptions();
    fetchTechnicalScope();
  }, []);

  useEffect(() => {
    if (userData) {
      setIsDisabled(!userData.permissions.CanEdit);
    }
  }, [userData]);

  useEffect(() => {
    if (isIdle && !autoSaveModal) {
      let check = JSON.stringify(formData) === JSON.stringify(initialformData);
      if (!check && !hasAutoSaved.current) {
        setAutoSaveModal(true);
      }
    }
  }, [isIdle]);

  useEffect(() => {
    let check = JSON.stringify(formData) === JSON.stringify(initialformData);
    if (!check) {
      updateAppData({ isFormChanged: true, showUnSavedModal: false });
    } else {
      updateAppData({ isFormChanged: false, showUnSavedModal: false });
    }
  }, [formData]);

  const fetchsProjectDetails = async () => {
    try {
      const data = await getProjectDetails(projectId);
      if (data) {
        setProjectDetails({ issaved: data.issaved });
        setIsDraftDisabled(data.issaved);
      }
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  //  Fetch Risks
  const fetchRisks = async () => {
    try {
      const data = await getRisks();
      let output = data.map((item: any) => ({
        key: item.Risk_key,
        value: item.Risk_name,
      }));
      // @ts-ignore
      setRisks(output);
    } catch (error) {
      console.error(" Failed to fetch Risk:", error);
    } finally {
    }
  };
  const fetchNewChassis = async () => {
    try {
      const data = await getNewChassisOptions();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez,
      }));
      // @ts-ignore
      setNewChassis(output);
    } catch (error) {
      console.error(" Failed to fetch New Chassis:", error);
    } finally {
    }
  };
  const fetchNewGoodies = async () => {
    try {
      const data = await getNewGoodiesOptions();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez,
      }));
      // @ts-ignore
      setNewGoodies(output);
    } catch (error) {
      console.error(" Failed to fetch New Goodies:", error);
    } finally {
    }
  };
  const fetchLockedFormulation = async () => {
    try {
      const data = await getLockedFormulationOptions();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez,
      }));
      // @ts-ignore
      setLockedFormulation(output);
    } catch (error) {
      console.error(" Failed to fetch Locked Formulation:", error);
    } finally {
    }
  };
  const fetchTSFormat = async () => {
    try {
      const data = await getTSFormatOptions();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez,
      }));
      // @ts-ignore
      setFormat(output);
    } catch (error) {
      console.error(" Failed to fetch Format:", error);
    } finally {
    }
  };
  const fetchTSPackType = async () => {
    try {
      const data = await getTSPackTypeOptions();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez,
      }));
      // @ts-ignore
      setPackType(output);
    } catch (error) {
      console.error(" Failed to fetch Pack Type:", error);
    } finally {
    }
  };
  const fetchLockedPackaging = async () => {
    try {
      const data = await getLockedPackagingOptions();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez,
      }));
      // @ts-ignore
      setLockedPackaging(output);
    } catch (error) {
      console.error(" Failed to fetch Locked Packaging:", error);
    } finally {
    }
  };

  const isEmptyObject = (obj: object) => {
    return JSON.stringify(obj) === "{}";
  };

  const fetchTechnicalScope = async () => {
    try {
      const response = await getTechnicalScopeById(projectKey);
      setLoading(false);

      if (!isEmptyObject(response.data)) {
        const bcData = response.data;

        setIsExisting(true);

        let technicalScopeData = {
          newChassis: JSON.stringify(bcData.New_Chasis),
          newGoodies: JSON.stringify(bcData.New_Goodies),
          lockedFormulation: JSON.stringify(bcData.Locked_Formulation),
          format: bcData.TSFormatkey?.map((f: any) => f.TSFormatkey.toString()) || [],
          packType: JSON.stringify(bcData.Pack_Type_Key),
          lockedPackaging: JSON.stringify(bcData.Locked_Packaging),
          comment: bcData.Comment || "",
          risk: JSON.stringify(bcData.Risk_Key),
        };
        setExistingFormats(bcData.TSFormatkey || []); // stored full objects
        setSelectedFormats(
          bcData.TSFormatkey?.map((f: any) => f.TSFormatkey.toString()) || []
        );
        setFormData(technicalScopeData);
        setInitialformData(technicalScopeData);
        setFormData((prev) => ({ ...prev, Ti_Id: bcData.Ti_Id }));
        setInitialformData((prev) => ({ ...prev, Ti_Id: bcData.Ti_Id }));
        setTechScopeId(bcData.Ti_Id);

        // update form fields in react-hook-form
        window.setTimeout(() => {
          Object.keys(technicalScopeData).forEach((key) => {
            setValue(
              key as any,
              technicalScopeData[key as keyof typeof technicalScopeData]
            );
          });
        }, 0);
      }
    } catch (error) {
      console.error(" Failed to fetch Technical Scope data:", error);
    }
  };


  //  Handle Form Change
  let handleFormChange = (name: string, value: any) => {
    setFormData({
      ...formData,
      [name]: value,
    });
    hasAutoSaved.current = false;
  };

  let handleFilterChange = async (name: any, value: any) => {
    setFormData({
      ...formData,
      [name]: value,
    });
    hasAutoSaved.current = false;
  };
  let handlePackaingFormatChange = async (name: any, values: string[]) => {
    setFormData((prev) => ({ ...prev, [name]: values }));
    setSelectedFormats(values);
    hasAutoSaved.current = false;
  };

  let pubLishProjectData = async () => {
    let res = await publishProjectOnSave(projectKey);
    if (res && res.issaved !== undefined) {
      setProjectDetails({ issaved: res.issaved });
      setIsDraftDisabled(res.issaved);
    }
  };
  const handleFormSubmit = (type: any, url: string) => {
    return handleSubmit((data) => onSubmit(data, type, url));
  };
  const toNullIfEmpty = (value: any) => value === "null" || value === "undefined" || value === undefined || value === "" ? null : value;
  const fetchRequiredField = async () => {
    try {
      const data = await getRequiredField(projectKey);
      return data;
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  let groupByModule = (errors: any) => {
    return errors.reduce((grouped: any, error: any) => {
      const { ModuleName, Message } = error;
      if (!grouped[ModuleName]) {
        grouped[ModuleName] = [];
      }
      grouped[ModuleName].push(Message);
      return grouped;
    }, {});
  };

  const getCompleteAuditTrail = (
    initialData: Record<string, any>,
    updatedData: Record<string, any>
  ): AuditEntry[] => {
    const audit: AuditEntry[] = [];
    const keys = Object.keys(initialData);
    for (const key of keys) {
      if (key === "project_id") continue;

      const oldValue = initialData[key];
      const newValue = updatedData[key];

      audit.push({
        fieldName: key,
        oldValue: String(oldValue),
        newValue: String(newValue),
      });
    }
    return audit;
  };

  const onSubmit = async (data: any, type: boolean, url: string) => {
    // console.log(formData);
    // return;
    let resField = await fetchRequiredField();
    if (type === true && resField?.data && resField?.data.length) {
      const groupedErrors = groupByModule(resField?.data);
      setValidationErrors(groupedErrors);
      setIsValidationError(true);
      return;
    }
    try {
      setLoading(true);
      const currentIds = selectedFormats.map((f) => Number(f));
      const existingIds = existingFormats.map((f) => f.TSFormatkey);

      const formatPayload = [
        // Keep existing records, mark status accordingly
        ...existingFormats.map((f) => {
          let status: string | null = null;
          if (!currentIds.includes(f.TSFormatkey)) {
            status = "deleted";
          }
          return {
            ...f,
            Project_Key: projectKey,
            Ti_Id: techScopeId,
            Status: status
          };
        }),
        // Add new records not in existingFormats
        ...currentIds
          .filter((id) => !existingIds.includes(id))
          .map((id) => ({
            Format_id: null,
            Project_Key: projectKey,
            Ti_Id: techScopeId,
            TSFormatkey: id,
            Status: "added",
          })),
      ];

      const payload = {
        Project_Key: projectKey,
        New_Chasis: toNullIfEmpty(formData.newChassis),
        New_Goodies: toNullIfEmpty(formData.newGoodies),
        Locked_Formulation: toNullIfEmpty(formData.lockedFormulation),
        TSFormatkey: formatPayload,
        Pack_Type_Key: toNullIfEmpty(formData.packType),
        Locked_Packaging: toNullIfEmpty(formData.lockedPackaging),
        Comment: toNullIfEmpty(formData.comment),
        Risk_Key: toNullIfEmpty(formData.risk),
      } as any;
      const initialPayload = {
        Project_Key: projectKey,
        New_Chasis: toNullIfEmpty(initialformData.newChassis),
        New_Goodies: toNullIfEmpty(initialformData.newGoodies),
        Locked_Formulation: toNullIfEmpty(initialformData.lockedFormulation),
        TSFormatkey: formatPayload,
        Pack_Type_Key: toNullIfEmpty(initialformData.packType),
        Locked_Packaging: toNullIfEmpty(initialformData.lockedPackaging),
        Comment: toNullIfEmpty(initialformData.comment),
        Risk_Key: toNullIfEmpty(initialformData.risk),
      };
      const completeAuditTrail = getCompleteAuditTrail(initialPayload, payload);
      {
        /* @ts-ignore */
      }
      payload.audit = completeAuditTrail;
      const res = !isExisting
        ? // @ts-ignore
        await createTechnicalScope(payload, projectKey)
        : await updateTechnicalScope(payload, projectKey);
      if (type === true) {
        await pubLishProjectData();
        setProjectDetails({ issaved: type });
        setIsDraftDisabled(type);
      }
      if (res) {
        fetchTechnicalScope();
        updateAppData({
          isFormChanged: false,
          showUnSavedModal: false,
          url: appData.url,
        });
        if (!isExisting) {
          setIsExisting(true);
        }
        setLoading(false);
        successToast(res.message);
        setTimeout(
          () => {
            if (type === true) {
              navigate(
                url ||
                `${projectVersion}/project/technical-scope/${projectId}/${projectKey}`
              );
            } else {
              navigate(
                url ||
                `${projectVersion}/project/planning-strategy/${projectId}/${projectKey}`
              );
            }
          },
          !isExisting ? 3000 : 2000
        );
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setLoading(false);
    }
  };
  let closeUnSavedModal = () => {
    updateAppData({ isFormChanged: true, showUnSavedModal: false, url: "" });
  };
  let saveUnSavedModal = () => {
    handleFormSubmit(true, appData.url)();
  };
  let draftSavedModal = () => {
    updateAppData({
      isFormChanged: false,
      showUnSavedModal: false,
      url: appData.url,
    });
    handleFormSubmit(false, appData.url)();
  };
  const discardModal = () => {
    // reset form, redirect, or just close modal
    updateAppData({
      isFormChanged: false,
      showUnSavedModal: false,
      url: appData.url,
    });
    navigate(appData.url);
  };
  let handleCancel = () => {
    if (!appData.isFormChanged) {
      navigate(`${projectVersion}/projects-grid`);
    } else {
      updateAppData({ isFormChanged: true, showUnSavedModal: true });
    }
  };

  let closeValidationModal = () => {
    setIsValidationError(false);
    setValidationErrors({});
  };

  const autoSave = async () => {
    setAutoSaveModal(false);
    try {
      let resField = await fetchRequiredField();
      if (resField?.data && resField?.data.length) {
        await handleFormSubmit(false, "")();
        hasAutoSaved.current = true;
      } else {
        await handleFormSubmit(true, "")();
        hasAutoSaved.current = true;
      }
    } catch (error) {
      console.error("Auto-save failed:", error);
    }
  };

  let closeAutoSave = () => {
    setAutoSaveModal(false);
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const uploadFlag = searchParams.get("isUpload") === "true";
    if (uploadFlag) {
      setIsUpload(true);
      searchParams.delete("isUpload");
    }
  }, [location.search, location.pathname]);

  let handlebackUpload = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete("isUpload");

    navigate(
      {
        pathname: location.pathname,
        search: searchParams.toString()
          ? `?${searchParams.toString()}`
          : "", // no query string if empty
      },
      { replace: true }
    );

    setIsUpload(false);
  };

  const handleProjectFileChange = async (file: any) => {
    const allowedTypes = [
      'application/pdf',
      'application/msword',                       // .doc
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
      'application/vnd.ms-excel',                 // .xls
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',       // .xlsx
      'application/vnd.ms-powerpoint',            // .ppt
      'application/vnd.openxmlformats-officedocument.presentationml.presentation' // .pptx
    ];
    if (!allowedTypes.includes(file.type)) {
      errorToast('Only PDF, PPT, XLS or DOC formats are allowed.');
      return;
    }
    setLoading(true)
    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB in bytes
    if (file.size > MAX_FILE_SIZE) {
      errorToast('File size must be less than 5 MB');
      return;
    }
    try {
      const formdata = new FormData();
      formdata.append("file", file, file.name);
      let data = await uploadProjectFile(projectKey, 4, formdata);
      //  successToast(data.message)
      setLoading(false)
      setRefreshTrigger(prev => prev + 1);

    } catch (error) {
      console.error('Error uploading file:', error);
      errorToast('Failed to upload file. Please try again.');
    }
  };

  let handleClickUpload = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("isUpload", "true");

    navigate(
      {
        pathname: location.pathname,
        search: `?${searchParams.toString()}`,
      },
      { replace: true }
    );
    setIsUpload(true);
  };
  console.log("form Data ->", formData)

  return (
    <>
      <ToastContainer />
      <div className="create-project-content">
        <Card className="" sx={{ padding: "10px" }}>
          <CardContent>
            <div className="button-top-form" style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Stack
                direction="row"
                spacing={2}
                sx={{ justifyContent: "start", pb: 4 }}
              >
                {
                  isUpload ?
                    <Button onClick={() => handlebackUpload()} sx={{ border: '0px', fontSize: '14px', color: '#B5B5B5', p: 0, textTransform: 'capitalize' }}><img src={circleArrowIcon} className="wtsback--img" /></Button>
                    :
                    null
                }

              </Stack>
              {
                !isUpload ?
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{ justifyContent: "end", pb: 4 }}
                  >
                    {
                      localStorage.user_info && JSON.parse(localStorage.user_info).Role !== '' ?
                        JSON.parse(localStorage.user_info).Role !== 'ProjectViewer' ?
                          <Tooltip title="Upload Documents" arrow>
                            <Button
                              onClick={() => handleClickUpload()}
                              sx={{ p: 0, minWidth: 'auto', width: '38px', height: '38px', border: '1px solid #000', borderRadius: '50%' }}
                            >
                              <img src={uploadIcon} className="icon-wt-uplad" />
                            </Button>
                          </Tooltip>
                          :
                          <>
                          </>
                        :
                        null
                    }
                    <Button
                      disabled={isDisabled}
                      onClick={handleFormSubmit(true, "")}
                      variant="contained"
                      sx={{
                        borderRadius: "30px",
                        px: 4,
                        py: 1,
                        textTransform: "capitalize",
                        color: "white !important",
                        backgroundColor: `${isDisabled ? "#d9d9d9 !important" : "#2a3fbf !important"
                          }`,
                      }}
                      className={classes.themeButton}
                    >
                      Submit
                    </Button>
                    <Button
                      disabled={isDisabled || projectDetails.issaved}
                      onClick={handleFormSubmit(false, "")}
                      variant="contained"
                      sx={{
                        borderRadius: "30px",
                        px: 4,
                        py: 1,
                        textTransform: "capitalize",
                        color: "white !important",
                        backgroundColor: "#2a3fbf !important",
                        "&.Mui-disabled": {
                          backgroundColor: "#d9d9d9 !important",
                          color: "#5f6368 !important",
                        },
                      }}
                      className={classes.themeButton}
                    >
                      Draft & Continue
                    </Button>
                    <Button
                      disabled={isDisabled}
                      onClick={handleCancel}
                      variant="contained"
                      sx={{
                        borderRadius: "30px",
                        px: 4,
                        py: 1,
                        textTransform: "capitalize",
                      }}
                      className={classes.cancelButton}
                    >
                      Cancel
                    </Button>
                  </Stack>
                  :
                  <>
                    <div className="file-upload-button">
                      <FileUpload isProjectUpload={true} isDisabled={false} onFileChange={handleProjectFileChange}
                        name="uploadPic" label="Browse" control={control} errors={errors} />
                    </div>
                  </>
              }

            </div>
            {
              isUpload ?
                <>
                  {/* @ts-ignore */}
                  <UploadList refreshTrigger={refreshTrigger} setLoading={setLoading} moduleId={4}></UploadList>
                </>
                :

                <form noValidate>
                  <div className="technicalScopeGrouping">
                    <div>
                      <h6>Formulation</h6>
                    </div>
                    <Grid container spacing={2} mt={2}>
                      <Grid size={4}>
                        <label className="txt-label-input">New Chassis</label>
                        <div className="project_drpdnw">
                          <Controller
                            name="newChassis"
                            control={control}
                            render={({ field }) => (
                              <SelectDropdown
                                isDisabled={isDisabled}
                                filterKey=""
                                label=""
                                value={field.value}
                                onChange={(val) => {
                                  field.onChange(val);
                                  handleFilterChange("newChassis", val);
                                  clearErrors("newChassis");
                                }}
                                options={newChassis}
                                isError={errors.newChassis ? true : false}
                              />
                            )}
                          />
                        </div>
                        {errors.newChassis && (
                          <p className="error-message">
                            {errors.newChassis.message}
                          </p>
                        )}
                      </Grid>
                      <Grid size={4}>
                        <label className="txt-label-input">New Goodies</label>
                        <div className="project_drpdnw">
                          <Controller
                            name="newGoodies"
                            control={control}
                            render={({ field }) => (
                              <SelectDropdown
                                isDisabled={isDisabled}
                                filterKey=""
                                label=""
                                value={field.value}
                                onChange={(val) => {
                                  field.onChange(val);
                                  handleFilterChange("newGoodies", val);
                                  clearErrors("newGoodies");
                                }}
                                options={newGoodies}
                                isError={errors.newGoodies ? true : false}
                              />
                            )}
                          />
                        </div>
                        {errors.newGoodies && (
                          <p className="error-message">
                            {errors.newGoodies.message}
                          </p>
                        )}
                      </Grid>
                      <Grid size={4}>
                        <label className="txt-label-input">
                          Locked - Formulation
                        </label>
                        <div className="project_drpdnw">
                          <Controller
                            name="lockedFormulation"
                            control={control}
                            render={({ field }) => (
                              <SelectDropdown
                                isDisabled={isDisabled}
                                filterKey=""
                                label=""
                                value={field.value}
                                onChange={(val) => {
                                  field.onChange(val);
                                  handleFilterChange("lockedFormulation", val);
                                  clearErrors("lockedFormulation");
                                }}
                                options={lockedFormulation}
                                isError={errors.lockedFormulation ? true : false}
                              />
                            )}
                          />
                        </div>
                        {errors.lockedFormulation && (
                          <p className="error-message">
                            {errors.lockedFormulation.message}
                          </p>
                        )}
                      </Grid>
                    </Grid>
                  </div>
                  <div className="technicalScopeGrouping">
                    <div>
                      <h6>Packaging</h6>
                    </div>
                    <Grid container spacing={2} mt={2}>
                      <Grid size={4}>
                        <label className="txt-label-input">Packaging Format</label>
                        <div className="project_drpdnw">
                          <Controller
                            name="format"
                            control={control}
                            render={({ field }) => (
                              <MultiSelectDropdown
                                isDisabled={isDisabled}
                                filterKey=""
                                label=""
                                value={selectedFormats}
                                onChange={(val) => {
                                  field.onChange(val);
                                  handlePackaingFormatChange("format", val);
                                  clearErrors("format");
                                }}
                                options={format}
                                isError={errors.format ? true : false}
                              />
                            )}
                          />
                        </div>
                        {errors.format && (
                          <p className="error-message">{errors.format.message}</p>
                        )}
                      </Grid>
                      <Grid size={4}>
                        <label className="txt-label-input">Scope of Change</label>
                        <div className="project_drpdnw">
                          <Controller
                            name="packType"
                            control={control}
                            render={({ field }) => (
                              <SelectDropdown
                                isDisabled={isDisabled}
                                filterKey=""
                                label=""
                                value={field.value}
                                onChange={(val) => {
                                  field.onChange(val);
                                  handleFilterChange("packType", val);
                                  clearErrors("packType");
                                }}
                                options={packType}
                                isError={errors.packType ? true : false}
                              />
                            )}
                          />
                        </div>
                        {errors.packType && (
                          <p className="error-message">{errors.packType.message}</p>
                        )}
                      </Grid>
                      <Grid size={4}>
                        <label className="txt-label-input">
                          Locked - Packaging
                        </label>
                        <div className="project_drpdnw">
                          <Controller
                            name="lockedPackaging"
                            control={control}
                            render={({ field }) => (
                              <SelectDropdown
                                isDisabled={isDisabled}
                                filterKey=""
                                label=""
                                value={field.value}
                                onChange={(val) => {
                                  field.onChange(val);
                                  handleFilterChange("lockedPackaging", val);
                                  clearErrors("lockedPackaging");
                                }}
                                options={lockedPackaging}
                                isError={errors.lockedPackaging ? true : false}
                              />
                            )}
                          />
                        </div>
                        {errors.lockedPackaging && (
                          <p className="error-message">
                            {errors.lockedPackaging.message}
                          </p>
                        )}
                      </Grid>
                    </Grid>
                  </div>
                  {/* Third row - 2 Fields */}
                  <div className="technicalScopeGrouping">
                    <Grid container spacing={2} mt={2}>
                      <Grid size={8}>
                        <label className="txt-label-input">Comment </label>
                        <TextInput
                          isDisabled={isDisabled}
                          className="comment-input"
                          isComment={true}
                          name="comment"
                          label=""
                          control={control}
                          errors={errors}
                          onChange={(e) =>
                            handleFormChange("comment", e.target.value)
                          }
                          multiline
                        />
                      </Grid>

                      <Grid size={4}>
                        <label className="txt-label-input">
                          Product Technical Risk
                        </label>
                        <div className="project_drpdnw">
                          <Controller
                            name="risk"
                            control={control}
                            render={({ field }) => (
                              <SelectDropdown
                                isDisabled={isDisabled}
                                filterKey=""
                                label=""
                                value={field.value}
                                onChange={(val) => {
                                  field.onChange(val);
                                  handleFilterChange("risk", val);
                                  clearErrors("risk");
                                }}
                                options={risks}
                                isError={errors.risk ? true : false}
                              />
                            )}
                          />
                        </div>
                        {errors.risk && (
                          <p className="error-message">{errors.risk.message}</p>
                        )}
                      </Grid>
                    </Grid>
                  </div>
                </form>
            }
          </CardContent>
        </Card>
      </div>

      {/* @ts-ignore */}
      <UnSavedModal
        close={closeUnSavedModal}
        saveUnSavedModal={saveUnSavedModal}
        draftSavedModal={draftSavedModal}
        discardModal={discardModal}
        isDraftDisabled={isDraftDisabled}
      />
      <ValidationModal
        validationErrors={validationErrors}
        open={isValidationError}
        closeValidationModal={closeValidationModal}
      />
      <AutoSaveModal
        open={autoSaveModal}
        closeAutoSave={closeAutoSave}
        autoSave={autoSave}
      ></AutoSaveModal>
    </>
  );
};

export default TechnicalScopeForm;
